module.exports = __webpack_public_path__ + "img/email-dark.85d04f37.svg";